import { LVTMetricTimeToFirstInteractionEvents } from './types';

export const TIME_TO_FIRST_INTERACTION_EVENTS: LVTMetricTimeToFirstInteractionEvents[] =
  ['click', 'scroll', 'keydown', 'touchstart'];
